import { render, staticRenderFns } from "./RightColumnCommonSlidesConfig.vue?vue&type=template&id=0224e978&scoped=true&"
import script from "./RightColumnCommonSlidesConfig.vue?vue&type=script&lang=js&"
export * from "./RightColumnCommonSlidesConfig.vue?vue&type=script&lang=js&"
import style0 from "./RightColumnCommonSlidesConfig.vue?vue&type=style&index=0&id=0224e978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224e978",
  null
  
)

export default component.exports